/* 邮件弹窗业务桥：复用实际动作与服务端回执，不拦截表单，不发送邮箱。 */
(function () {
  'use strict';
  var api = window.__ga4Journey, bridge = window.__ga4PopupBridge;
  if (!api || !bridge || window.__ga4EmailReady) return;
  window.__ga4EmailReady = true;
  var states = new Map(), prefix = 'ga4-popup-v1:', ttl = 30 * 60 * 1000;
  var storageAvailable = true;
  var awaitingInitialDecision = !api.hasConsentDecision();
  function storageKey(key) { return prefix + key; }
  function remove(key) { try { sessionStorage.removeItem(storageKey(key)); } catch (_) { storageAvailable = false; } }
  function clear() {
    states.clear();
    try {
      Object.keys(sessionStorage).filter(function (key) { return key.indexOf(prefix) === 0; }).forEach(function (key) { sessionStorage.removeItem(key); });
    } catch (_) { storageAvailable = false; }
  }
  function read(key) {
    try {
      var raw = sessionStorage.getItem(storageKey(key));
      if (!raw || raw.length > 3000) return null;
      var state = JSON.parse(raw);
      if (!state || !/^[a-zA-Z0-9_-]{1,100}$/.test(state.id || '') ||
          !/^[a-zA-Z0-9_-]{1,100}$/.test(state.origin || '') ||
          !Number.isFinite(state.expires) || state.expires < Date.now() || state.expires > Date.now() + ttl ||
          !Number.isFinite(state.opened) || state.opened > Date.now() ||
          !Number.isInteger(state.attempt) || state.attempt < 0 || state.attempt > 100 ||
          (state.attempt > 0 && !/^[a-zA-Z0-9_-]{1,100}$/.test(state.attemptId || ''))) { remove(key); return null; }
      state.seen = state.seen && typeof state.seen === 'object' ? state.seen : {};
      return state;
    } catch (_) { storageAvailable = false; return null; }
  }
  function save(key, state) {
    if (!api.isAllowed() || (!state.attempt && !state.result)) return;
    try { sessionStorage.setItem(storageKey(key), JSON.stringify(state)); }
    catch (_) { storageAvailable = false; }
  }
  function create(properties, viewed) {
    return { id: api.uuid(), origin: api.pageId(), source: properties.popup_impression_id || '',
      opened: Date.now(), expires: Date.now() + ttl, trigger: properties.trigger_type || 'unknown',
      association: viewed ? 'observed' : 'partial', attempt: 0, attemptId: '',
      seen: {}, result: '', submitted: false,
      experiment: /^scratch-form-v1:[ab]$/.test(properties.form_experiment || '') ? properties.form_experiment : '' };
  }
  function skipped(name, reason) { api.noteSkipped(name, reason); }
  function receive(name, p) {
    if (!api.isAllowed()) return;
    if (['scratch-popup', 'newsletter-popup'].indexOf(p.popup_id) < 0 || !/^[a-zA-Z0-9_-]{1,100}$/.test(p.section_id || '')) return;
    var key = p.popup_id + ':' + p.section_id, isResult = /email_popup_submit_(succeeded|failed)$/.test(name);
    if (isResult && p.result_confirmed !== true) { skipped(name, 'unconfirmed_server_result'); return; }
    var state = states.get(key);
    if (state && state.expires < Date.now()) { states.delete(key); state = null; }
    if (isResult || !state) {
      var stored = read(key);
      // 回跳的 UI 不再保存第二套展示/提交状态；无来源 ID 时恢复 GA4 自己的关联。
      if (stored && (!p.popup_impression_id || stored.source === p.popup_impression_id)) state = stored;
      else if (isResult && stored && p.popup_impression_id) { skipped(name, 'mismatched_popup_result'); return; }
    }
    if (name === 'email_popup_viewed' && state && state.source !== (p.popup_impression_id || '')) state = null;
    if (!state) {
      state = create(p, name === 'email_popup_viewed');
      if (isResult) { state.association = 'unmatched_result'; state.experiment = ''; }
      if (states.size >= 20) { skipped(name, 'popup_context_limit'); return; }
      states.set(key, state);
    } else states.set(key, state);
    // 旧 section 的原生 submit 重入不能再凭空建立一次重试。
    if (name === 'email_popup_action' && p.interaction_type === 'submit_retry') { skipped(name, 'legacy_submit_retry'); return; }
    var submission = name === 'email_popup_submitted';
    if (submission && ((!p.submission_id && state.submitted) ||
        (p.submission_id && p.submission_id === state.lastSubmissionId))) { skipped(name, 'duplicate_popup_submission'); return; }
    var retry = submission && state.submitted;
    if (retry) {
      name = 'email_popup_action';
      p = Object.assign({}, p, { interaction_type: 'submit_retry', element_name: 'email_form' });
    }
    var dedupe = name + ':' + (name === 'email_popup_action' ? p.interaction_type : '');
    if (!submission && !isResult && state.seen[dedupe]) { skipped(name, 'duplicate_popup_action'); return; }
    if (isResult && state.result === name + ':' + state.attemptId) { skipped(name, 'duplicate_popup_result'); return; }
    if (submission) {
      state.attempt++; state.attemptId = api.uuid(); state.submitted = true;
      state.lastSubmissionId = p.submission_id || '';
      delete state.seen['email_popup_closed:'];
      state.result = ''; state.expires = Date.now() + ttl;
    }
    var props = {
      popup_id: p.popup_id, popup_version: p.popup_version || 'unknown', section_id: p.section_id,
      popup_impression_id: state.id, origin_page_view_id: state.origin, association_status: state.association,
      trigger_type: state.trigger, popup_stage: p.popup_stage || (isResult ? 'result' : 'email_form'),
      submission_attempt: state.attempt
    };
    if (state.attemptId) props.attempt_id = state.attemptId;
    // 原提交上下文的分组优先于回跳页，缺失关联的结果不猜测版本。
    if (/^scratch-form-v1:[ab]$/.test(state.experiment || '')) props.form_experiment = state.experiment;
    var elapsed = Math.max(0, Date.now() - state.opened);
    if (name === 'email_popup_interacted') {
      props.interaction_type = p.interaction_type || 'unknown'; props.time_to_interact_ms = elapsed;
    }
    if (name === 'email_popup_action') {
      props.interaction_type = p.interaction_type || 'unknown'; props.element_name = p.element_name || 'unknown';
      props.time_since_open_ms = elapsed;
      if (['pointer', 'keyboard'].indexOf(p.interaction_method) >= 0) props.interaction_method = p.interaction_method;
      if (p.reveal_method) props.reveal_method = p.reveal_method;
      if (typeof p.scratch_coverage_pct === 'number') props.scratch_coverage_pct = p.scratch_coverage_pct;
    }
    if (name === 'email_popup_submitted') props.time_to_submit_ms = elapsed;
    if (name === 'email_popup_closed') {
      props.close_method = p.close_method || 'unknown';
      props.had_interaction = !!p.had_interaction || !!state.seen['email_popup_interacted:'];
      props.had_submitted = state.submitted; props.time_to_close_ms = elapsed;
      // 实验增加一个字段；had_submitted 可由 submission_attempt > 0 推导，保证最多 25 参数。
      if (props.form_experiment) delete props.had_submitted;
      // 成功只取 GA4 已确认的服务端回执，不能沿用仅凭 URL 的业务 UI 成功状态。
      props.submission_succeeded = state.result === 'email_popup_submit_succeeded:' + state.attemptId;
      if (typeof p.reward_revealed === 'boolean') props.reward_revealed = p.reward_revealed;
      if (typeof p.form_viewed === 'boolean') props.form_viewed = p.form_viewed;
    }
    if (isResult) {
      props.time_to_result_ms = elapsed;
      props.result_without_stored_impression = state.association === 'unmatched_result';
      if (name === 'email_popup_submit_failed') props.error_type = 'server_validation';
    }
    if (api.emit(name, props)) {
      state.seen[dedupe] = true;
      if (isResult) state.result = name + ':' + state.attemptId;
      if (state.attempt || isResult) save(key, state);
    }
    // 关闭只结束界面生命周期；待处理提交和已确认回执保留原 TTL，避免刷新重记。
    // 未提交的新展示不会覆盖旧提交，因为 save() 只保存提交/回执。
    if (name === 'email_popup_closed' && !state.attempt && !state.result) states.delete(key);
  }
  function observePendingResult() {
    // 许可 API 延迟时不缓存动作；首次允许后，只核对已获许可提交的当前服务端回执。
    document.querySelectorAll('[id^="ScratchPopup-"], [id^="NewsletterPopup-"]').forEach(function (popup) {
      var scratch = popup.id.indexOf('ScratchPopup-') === 0;
      var popupId = scratch ? 'scratch-popup' : 'newsletter-popup';
      var sectionId = popup.id.slice(scratch ? 'ScratchPopup-'.length : 'NewsletterPopup-'.length);
      if (!/^[a-zA-Z0-9_-]{1,100}$/.test(sectionId)) return;
      var success = popup.querySelector(scratch ? 'form [data-sxp-server-success]' : 'form [data-ga4-email-result="success"]');
      var failure = popup.querySelector(scratch ? 'form [data-sxp-server-errors]' : 'form [data-ga4-email-result="failed"]');
      if ((!success && !failure) || (success && failure)) return;
      var state = read(popupId + ':' + sectionId);
      if (!state || !state.submitted || !state.attempt) return;
      receive(failure ? 'email_popup_submit_failed' : 'email_popup_submit_succeeded', {
        popup_id: popupId, section_id: sectionId,
        popup_version: scratch ? 'scratch-email-popup-v5' : 'email-popup-v3',
        popup_impression_id: state.source, popup_stage: failure ? 'email_form' : 'success',
        trigger_type: 'submit_result', result_confirmed: true
      });
    });
  }
  if (!api.isAllowed() && !awaitingInitialDecision) clear();
  api.onConsent(function (allowed) {
    var firstDecision = awaitingInitialDecision;
    awaitingInitialDecision = false;
    if (!allowed) clear();
    else if (firstDecision) observePendingResult();
  });
  // 许可已在 core 启动时就绪也需要恢复回执；先于队列中的关闭事件处理。
  if (api.isAllowed()) observePendingResult();
  bridge.connect(receive);
  api.registerModule('email', function () {
    return { version: 'email-form-experiment-v4', activeContexts: states.size, resultStorageAvailable: storageAvailable,
      scratchPopups: document.querySelectorAll('[id^="ScratchPopup-"]').length,
      newsletterPopups: document.querySelectorAll('[id^="NewsletterPopup-"]').length, resultContextTtlMs: ttl };
  });
})();
